import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsTop, TestimonialsMore } from './components/Testimonials';
import { Pain } from './components/Pain';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { ComparisonAI } from './components/ComparisonAI';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="w-full bg-white font-sans text-slate-900" data-id="element-0" data-mp="2wip2ssgwz006">
      <main className="w-full" data-id="element-1" data-mp="28te2td7e19n3">
        <Hero data-id="element-2" data-mp="28skzynbjv4a8" />
        <TestimonialsTop data-id="element-3" data-mp="28s2ztflro5x1" />
        <Pain data-id="element-4" data-mp="23vunsb2v8su3" />
        <Product data-id="element-5" data-mp="23u9t8lgjx9w8" />
        <Bonuses data-id="element-6" data-mp="23utcc5hxu4bu" />
        <Countdown data-id="element-7" data-mp="23t8heerpojdg" />
        <Pricing data-id="element-8" data-mp="3ijxq4swlw4ky" />
        <ComparisonAI data-id="element-9" data-mp="3ikh7o8icgqyg" />
        <TestimonialsMore data-id="element-10" data-mp="3iiwg8rrbto4t" />
        <Guarantee data-id="element-11" data-mp="3ijpe138b53at" />
        <FAQ data-id="element-12" data-mp="3ii4q3wgi0ilx" />
        <CostOfInaction data-id="element-13" data-mp="3mlaxx8j9ehui" />
        <FinalCTA data-id="element-14" data-mp="3mkhlbqxmcy4g" />
      </main>
      <Footer data-id="element-15" data-mp="3mjq2zht18ww4" />
      <StickyCTA data-id="element-16" data-mp="3mj6ipufwtwex" />
    </div>;
}